import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { IRequestCallback } from '@df/api/request/request.service';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { LoqateEmailValidateDirective } from '@df/module-loqate/email/loqate-email.validator';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';
import { IfNotStandaloneDirective } from '@df/module-pwa/utils/if-not-standalone.directive';
import { TimeoutService } from '@df/ng/timeout.service';
import { LoginFormComponentDef } from '@df/session/login/login-form.component.def';
import { Login } from '@df/session/login/login.interfaces';
import { MatchCheckDirective } from '@df/ui/form/match-check.directive';
import { RadioGroupDirective } from '@df/ui/form/radio/radio.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { CMS_CONFIG_NEWSLETTER, IICmsConfigNewsletterData } from '../../../cms/config/newsletter.cms-config';
import { SocialLoginComponent } from '../../../ui/3rdparty/social-login.component';
import { ActionComponent } from '../../../ui/api/action.component';
import { CheckboxComponent } from '../../../ui/form/checkbox';
import { InputWrapBodyDirective } from '../../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../../ui/form/input-wrap.component';
import { RadioComponent } from '../../../ui/form/radio';
import { ResultComponent } from '../../../ui/resut/result.component';
import { ILoginViewLayoutContent } from '../../view/layout/login-view-layout.component';
@Component({
    selector: 'login-form-retail',
    templateUrl: './login-form-retail.component.html',
    standalone: true,
    imports: [
        ActionComponent,
        FormsModule,
        ICmsClientModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        LoqateEmailValidateDirective,
        MatchCheckDirective,
        MuiInputDirective,
        NgClass,
        RadioComponent,
        RadioGroupDirective,
        ResultComponent,
        RouterLink,
        SocialLoginComponent,
        IfNotStandaloneDirective,
        TranslationModule,
        CheckboxComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormRetailComponent extends LoginFormComponentDef implements OnInit {
    @Input()
    content?: ILoginViewLayoutContent;

    @Input()
    loyaltyDescription?: string;

    @Input()
    loyaltyTitle?: string;

    @Output()
    onSuccess = new EventEmitter();

    /**
     * By default register form it is not visible
     */
    @Input()
    registerPageIsVisible = false;
    protected newsletterPreselection: string | null = null;

    protected timeoutService = inject(TimeoutService);
    protected cmsConfigResource = inject(ICmsConfigResource);
    private pwaIntegrationService = inject(PwaIntegrationService);
    protected router = inject(Router);

    override ngOnInit() {
        super.ngOnInit();
        this.cmsConfigResource.loadModelByUrl(CMS_CONFIG_NEWSLETTER).then(() => {
            const config = this.cmsConfigResource.getModelByUrl(CMS_CONFIG_NEWSLETTER) as ICmsConfig<IICmsConfigNewsletterData>;
            const preselection = config?.data?.content?.emailNewsletterPreselection;
            if (preselection === 'all') {
                this.newsletterPreselection = '1';
                ((this.data as Login.IRegisterFormData).newsletter as string | number) = this.newsletterPreselection;
            }
        });
    }
    protected override setCheckResult(checkResult?: Login.IResponseAccountExists) {
        if (this.registerPageIsVisible === checkResult?.exists) {
            this.registerPageIsVisible = !checkResult?.exists;
        }
        super.setCheckResult(checkResult);
    }

    protected showRegisterForm(status: boolean): void {
        this.registerPageIsVisible = status;
        this.detectChanges();
    }

    get registerData(): Partial<Login.IRegisterFormData> {
        return this.data as Partial<Login.IRegisterFormData>;
    }

    get showLoyaltyTerms(): boolean {
        return !!this.loyaltyTitle && this.registerPageIsVisible && !!this.pwaIntegrationService.isStandalone;
    }

    private emitSuccess() {
        this.onSuccess.emit();
    }

    override login(onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        super.login(() => {
            this.emitSuccess();
            if (this.pwaIntegrationService.isStandalone) {
                this.router.navigate(['/']);
            }
        }, onError);
    }

    override register(onSuccess?: IRequestCallback, onError?: IRequestCallback) {
        super.register(() => {
            this.emitSuccess();
            if (this.pwaIntegrationService.isStandalone) {
                this.router.navigate(['/']);
            }
        }, onError);
    }

    protected get isLoginPage(): boolean {
        return this.router.url.includes('/login');
    }
}
